<template>
  <div class="locale-switcher">
    <div v-if="!isMobile" class="locale-switcher__list">
      <div
        class="locale-switcher__locale"
        :class="{ active: selectedLocale === locale.key }"
        v-for="locale in availableLocales"
        :key="`locale-${locale.key}`"
        @click="switchLocale(locale.key)"
      >
        {{ locale.label }}
      </div>
    </div>
    <div v-else>
      <MobileSwitchLocale
          :available-locales="availableLocales"
          :selected-locale="selectedLocale"
          @locale-changed="switchLocale"
      />
    </div>
  </div>
</template>

<script>
import { AVAILABLE_LOCALES } from '@js-app/const/config'
import { mapState } from 'vuex'
import { SET_CURRENT_LOCALE } from '@vue-app/store/const/actions-types'
import MobileSwitchLocale from "@/vue/components/header/parts/MobileSwitchLocale.vue";

function getCookie(name) {
  const m = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
  return m ? decodeURIComponent(m[2]) : null
}

export default {
  name: 'LocaleSwitcher',
  data() {
    return {
      availableLocales: AVAILABLE_LOCALES,
      isMobile: false
    }
  },
  components: {
    MobileSwitchLocale,
  },
  computed: {
    ...mapState(['selectedLocale']),
  },
  mounted() {
    const cookieLocale = getCookie('CP-Locale')
    const stored = localStorage.getItem('selectedLocale') ?? 'uk'
    const init = cookieLocale || stored
    if (init && init !== this.selectedLocale) {
      this.applyLocale(init)
    }

    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  methods: {
    applyLocale(locale) {
			console.log('applyLocale', locale);
      this.$i18n.locale = locale
      this.$store.dispatch(SET_CURRENT_LOCALE, locale)
      localStorage.setItem('selectedLocale', locale)
      document.cookie = `CP-Locale=${locale};path=/;max-age=${
        60 * 60 * 24 * 30
      }`
    },
    switchLocale(locale) {
			console.log('switchLocale', locale);
      this.$store.dispatch(SET_CURRENT_LOCALE, locale)
    },

    checkMobile() {
      this.isMobile = window.innerWidth <= 568
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@css-app/variables';
@import '@css-app/mixins';
.locale-switcher {
  display: flex;
  align-items: center;
  &__title {
    position: relative;
    font-weight: 500;
    font-size: pxToRem(12);
    line-height: pxToRem(15);
    color: $text2;
    padding-right: 7px;
    margin-right: 7px;

    &:after {
      position: absolute;
      content: '';
      display: block;
      height: 100%;
      width: 1px;
      background: $stroke;
      top: 0;
      right: 0;
    }
  }

  &__list {
    display: flex;
    align-items: center;
  }

  &__locale {
    padding: 2px 7px;
    border-radius: 21px;
    margin-right: 4px;
    font-size: pxToRem(14);
    line-height: pxToRem(20);
    background-color: transparent;
    text-transform: uppercase;
    color: #64748B;
    cursor: pointer;
    transition: background-color 0.2s linear, color 0.2s linear;

    &:hover {
      color: #3b4656;
    }

    &:last-child {
      margin-right: 0;
    }

    &.active {
      font-weight: 500;
      color: #3b4656;
    }
  }
}
@media screen and (max-width: 992px) {
  .locale-switcher {
    margin-left: 32px;
    margin-top: auto;
    &__title {
      display: none;
    }

    &__locale {
      padding: 5px 12px;
      border-radius: 18px;
      font-size: pxToRem(18);
      line-height: pxToRem(22);
      color: #465a8b;
      margin-right: 30px;

      &.active {
        background-color: #e0e6f2;
        color: #465a8b;
      }
    }
  }
}
</style>
